import { Environment } from '@/utils/environment/environment.interface';
import { I18nService } from '@/utils/i18n/i18n.service';
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { InformationProvider } from './information/information.provider';

interface GlobalInfoMessage {
    enabled: boolean;
    message: string;
    severity: string;
    icon: string;
}

@Injectable({
    providedIn: 'root'
})
export class GlobalInfoProvider {
    private _http = inject(HttpClient);
    private _informationProvider = inject(InformationProvider);
    private _i18n = inject(I18nService);
    private _env = inject(Environment);

    async showGlobalInfoMessage() {
        await this._i18n.waitForTranslationsLoad();

        const lang = this._i18n.getCurrentLangR();

        return firstValueFrom(this._http.get<GlobalInfoMessage>(this._env.globalInfoMessageUrl))
            .then(message => {
                if (!message || !message.enabled) {
                    return false;
                }
                this._informationProvider.showNotification(
                    message[('message_' + lang) as 'message'] || message['message_fr' as 'message'],
                    message.severity as any,
                    15000
                );
            })
            .catch(err => {
                console.error('error while fetching global info message', err);
                return false;
            });
    }
}
